import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import navInit from './modules/nav';
import noUiSliderInit from './modules/no-ui-slider';
import tabsInit from './modules/tabs';
import scrollDetectorInit from './modules/scroll-detector';
import countersInit from './modules/counter';
import galleryInit from './modules/wp-gallery';
import placeholderInit from './modules/placeholder';
import slickInit from './modules/slick';
import fixtoInit from './modules/fixto';
import mieszkaniaTableInit from './modules/mieszkania-table';
import searchFormInit from './modules/search-form';
// import favInit from './modules/fav';
// import mapInit from './modules/map-tooltip';
import googleMapInit from './modules/google-map';
import poiGoogleMapInit from './modules/poi-google-map';
import tableSortInit from './modules/table-sort';
import scrollTopInit from './modules/scroll-top';
import popupInit from './modules/popup';
import scrollLinksInit from './modules/scroll-links';
import hashHandlerInit from './modules/hash-handler';

(function ($) {

	$.fancybox.defaults.buttons = [
		// "zoom",
		//"share",
		"slideShow",
		//"fullScreen",
		//"download",
		"thumbs",
		"close"
	];

	hashHandlerInit();

	$(document).ready(function () {

		$('a[href="#"]').click((e) => { e.preventDefault() });

		documentInit();
		mobileNavInit();
		navInit();
		scrollTopInit();
		scrollLinksInit();

		noUiSliderInit();
		tabsInit();
		countersInit();
		placeholderInit();
		slickInit();
		tableSortInit();
		popupInit();

		googleMapInit();
		poiGoogleMapInit();

		// mapInit();

		scrollDetectorInit();

		galleryInit();
		fixtoInit();
		mieszkaniaTableInit();
		searchFormInit();
		// favInit();


		$(document).trigger('hp-plugins-loaded');

		$(document.body).addClass('is-loaded');

		$(window).trigger('resize');
		$(window).trigger('scroll');

	});

})(jQuery);